import React, { FC, MouseEvent } from 'react';
import { UnfoldMore } from '@mui/icons-material';
import clsx from 'clsx';

import './PlanTypePill.scss';

interface PlanTypePillProps {
  label: string;
  selected: boolean;
  onPress: (event: MouseEvent<HTMLButtonElement>) => void;
  onExpandPress?: (event: MouseEvent<HTMLElement>) => void;
  count?: number;
}

const PlanTypePill: FC<PlanTypePillProps> = ({
  label,
  selected,
  onPress,
  onExpandPress,
  count,
}) => {
  return (
    <div
      className={clsx('plan-type-pill', {
        'plan-type-pill--selected': selected,
        'plan-type-pill--no-expand': !onExpandPress,
      })}
    >
      <button type="button" className="plan-type-pill__body" onClick={onPress}>
        <span className="plan-type-pill__label">{label}</span>
        {typeof count === 'number' && count > 0 && (
          <span className="plan-type-pill__count">{count}</span>
        )}
      </button>
      {onExpandPress && (
        <button
          type="button"
          className="plan-type-pill__expand"
          onClick={(event) => {
            event.stopPropagation();
            onExpandPress(event);
          }}
          aria-label={`Configure ${label}`}
        >
          <UnfoldMore fontSize="inherit" />
        </button>
      )}
    </div>
  );
};

export default PlanTypePill;
